export const XP_PER_LEVEL = [
    0, 100, 250, 500, 1000, 2000, 4000, 8000, 16000, 32000
];
export const MAX_LEVEL = XP_PER_LEVEL.length; // 10
export function calculateLevel(xp) {
    for (let i = XP_PER_LEVEL.length - 1; i >= 0; i--) {
        if (xp >= XP_PER_LEVEL[i])
            return i + 1;
    }
    return 1;
}
export function calculateMaxSlots(level) {
    // L1: 1 slot, L2: 2 slots, L4: 3 slots, L6: 4 slots, etc.
    return Math.max(1, Math.floor(level / 2) + 1);
}
export function createInitialProgression() {
    return {
        xp: 0,
        level: 1,
        unlockedChips: ['chip_base_speed'],
        equippedChips: [],
        maxSlots: 1,
    };
}
export function addXp(profile, amount) {
    const newXp = profile.xp + amount;
    const newLevel = calculateLevel(newXp);
    const newMaxSlots = calculateMaxSlots(newLevel);
    return {
        ...profile,
        xp: newXp,
        level: newLevel,
        maxSlots: newMaxSlots
    };
}
export function unlockChip(profile, chipId) {
    if (profile.unlockedChips.includes(chipId)) {
        return profile;
    }
    return {
        ...profile,
        unlockedChips: [...profile.unlockedChips, chipId]
    };
}
export function equipChip(profile, chipId, allChips) {
    if (!profile.unlockedChips.includes(chipId)) {
        throw new Error(`Chip ${chipId} not unlocked`);
    }
    const chip = allChips[chipId];
    if (!chip) {
        throw new Error(`Unknown chip ${chipId}`);
    }
    if (profile.equippedChips.includes(chipId)) {
        return profile;
    }
    const currentCost = profile.equippedChips
        .map(id => allChips[id]?.slotCost || 1)
        .reduce((a, b) => a + b, 0);
    if (currentCost + chip.slotCost > profile.maxSlots) {
        throw new Error(`Not enough slots to equip ${chipId}`);
    }
    return {
        ...profile,
        equippedChips: [...profile.equippedChips, chipId]
    };
}
export function unequipChip(profile, chipId) {
    return {
        ...profile,
        equippedChips: profile.equippedChips.filter(id => id !== chipId)
    };
}
